import { colors } from "@/styles/colors";
import styled, { css, keyframes } from "styled-components";

const spin = keyframes`
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
`;
export const Btn = styled.button<{ $danger?: boolean }>`
  position: relative;

  padding: 0.75rem 1rem;
  font-weight: 600;
  border: none;
  border-radius: 5px;
  color: #${colors.monocromatic._900};
  background: #${colors.primary._500};
  transition: all 0.15s;
  overflow: hidden;

  &,
  .text {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
  }

  .decorator {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 0;
    aspect-ratio: 1/1;
    background: #${colors.primary._300};
    border-radius: 9999px;
    transition: all 0.35s;
  }

  .text {
    position: relative;
    gap: 1rem;
  }

  &:hover {
    .decorator {
      border-radius: 0;
      width: 100%;
    }
  }

  &:disabled {
    cursor: default;
    background: #${colors.monocromatic._700};

    .decorator {
      display: none;
    }
  }

  .spin {
    --size: 1.5em;
    position: relative;
    display: flex;

    min-width: var(--size);
    min-height: var(--size);
    max-width: var(--size);
    max-height: var(--size);

    border: 2px solid #${colors.monocromatic._900};
    border-bottom: 2px solid transparent;
    border-radius: 9999px;
    animation: ${spin} 1s infinite linear forwards;
  }

  ${({ $danger }) =>
    $danger
      ? css`
          background: #f33;
          .decorator {
            background: #e22;
          }
        `
      : ""}
`;
